import type {ThemeConfig, ThemeId} from "./types";

/**
 * Central registry of all available themes.
 *
 * To add a custom theme:
 *  1. Extend the `ThemeId` union in types.ts  (e.g. | 'ocean')
 *  2. Add its entry here with the correct colorScheme
 *  3. Web: create a CSS file in design-system-web/src/themes/ and import it in global.css
 *  4. Native: add a @variant block in the native CSS and register it in metro.config.js
 */
export const THEME_REGISTRY: Record<ThemeId, ThemeConfig> = {
  light: {builtin: true, colorScheme: "light", id: "light", label: "Light"},
  dark: {builtin: true, colorScheme: "dark", id: "dark", label: "Dark"},
};
